import { useMemo } from 'react';
import { useLockBodyScroll } from '@/hooks/useLockBodyScroll';
import SidebarContent from './components/SidebarContent';
import SidebarOverlay from './components/SidebarOverlay';

interface Props {
  isOpenSideBar: boolean;
  isMobile: boolean;
  isMenuMinify: boolean;
  handleCloseSideBar: () => void;
  isHomePage: boolean;
}

export function SideBar({
  isOpenSideBar,
  isMobile,
  handleCloseSideBar,
  isMenuMinify,
  isHomePage,
}: Props) {
  const isOpen = useMemo(() => {
    return isMobile ? isOpenSideBar : false;
  }, [isOpenSideBar, isMobile]);

  useLockBodyScroll(isOpen);

  return (
    <>
      <SidebarOverlay isOpen={isOpen} handleCloseSideBar={handleCloseSideBar} />
      <SidebarContent isMenuMinify={isMenuMinify} isOpen={isOpen} handleCloseSideBar={handleCloseSideBar} isHomePage={isHomePage} />
    </>
  );
}
